/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Risk Modelling Platform API
 * The API for the risk modelling platform
 * OpenAPI spec version: 1.0
 */

export type ServiceCreateStatewideSnapshotProjectInputType =
  (typeof ServiceCreateStatewideSnapshotProjectInputType)[keyof typeof ServiceCreateStatewideSnapshotProjectInputType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ServiceCreateStatewideSnapshotProjectInputType = {
  "statewide-snapshot": "statewide-snapshot",
} as const;
